/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit CheckPayment/view.blocks to change it.
import CheckNumberInput from './CheckNumberInput/index'
import CheckPayerNameInput from './CheckPayerNameInput/index'
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function CheckPayment({
  children,
  viewPath = "/App/Account/EmbeddableCoreMessageListener/PaymentsPostPayment/Content/Content/Content/PaymentMethods/CheckPayment"
  
}) {
  return (<React.Fragment
>
<div
  data-testid="CheckPayment.Vertical"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical}`}
>
<CheckNumberInput
  viewPath={`${viewPath}/CheckNumberInput`}
/>
<CheckPayerNameInput
  viewPath={`${viewPath}/CheckPayerNameInput`}
/>
</div>
{children}
</React.Fragment>)
}